import { render } from "./RecommendationCarousel.vue?vue&type=template&id=6262ae7a"
import script from "./RecommendationCarousel.vue?vue&type=script&lang=js"
export * from "./RecommendationCarousel.vue?vue&type=script&lang=js"

import "./recommendationCarousel.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__